import React from "react";
import { horizontalBarStateSelector } from "./horizontalBarDomain";
import { useCustomScrollObjectSelector } from "../_store/customScrollSelectorHook";
import { useContext, useState } from "react";
import { isAllValuesDefined } from "../_utils/predicates";
import { getThumbSize } from "../_shared/getThumbSize";
import { toInt } from "../_utils/global";
import { PerfectScrollContext } from "../scroll/perfectScrollContext";
import {
    defaultThumbParams,
    IThumbParams,
    TThumbApi,
} from "../_shared/IThumbParams";
import { useMemoEx } from "../_utils/hooks";
import { useHorizontalRailClickHandler } from "../_handlers/clickRail";
import { useDragHorizontalThumbHandler } from "../_handlers/dragThumb";
import { classNames } from "../_utils/classNames";

const h = "horizontal";

const localNames = {
    rail: bl => classNames.element.rail(bl, h),
    thumb: bl => classNames.element.thumb(bl, h),
    scrolling: bl => classNames.state.scrolling(bl, h),
};

export function HorizontalBarElement({
    style = {},
    thumbStyle = {},
    block = "ngd-perfect-scrollbar",
}) {
    const [rail, setRail] = useState<HTMLDivElement>();

    const customScrollContext = useContext(PerfectScrollContext);
    const i = useCustomScrollObjectSelector(
        horizontalBarStateSelector,
        customScrollContext
    );

    const [c, getC] = useMemoEx(() => calculateThumbParams(rail, i), [i, rail]);
    const args: TThumbApi = [rail, getC, customScrollContext.store];

    const tStyle = {
        ...thumbStyle,
        left: c.thumbOffset + "px",
        width: c.thumbMeasure + "px",
    };

    const onRailClick = useHorizontalRailClickHandler(...args);
    const { isDragging, ...thumbEvents } = useDragHorizontalThumbHandler(
        ...args
    );

    let className = localNames.rail(block);
    if (isDragging) className += " " + localNames.scrolling(block);

    return !i.scrollbarXActive ? null : (
        <div
            ref={setRail}
            style={style}
            onMouseDown={onRailClick}
            className={className}>
            <div
                style={tStyle}
                {...thumbEvents}
                className={localNames.thumb(block)}
            />
        </div>
    );
}

function calculateThumbParams(
    rail: HTMLDivElement,
    i: ReturnType<typeof horizontalBarStateSelector>
): IThumbParams {
    if (!rail) return defaultThumbParams;

    if (
        !isAllValuesDefined(
            i.containerWidth,
            i.contentWidth,
            i.scrollLeft,
            i.negativeScrollAdjustment
        )
    )
        return defaultThumbParams;
    /*
i.railXWidth = i.containerWidth - i.railXMarginWidth;
i.railXRatio = i.containerWidth / i.railXWidth;
i.scrollbarXWidth = getThumbSize(
i,
toInt((i.railXWidth * i.containerWidth) / i.contentWidth)
);
i.scrollbarXLeft = toInt(
((i.negativeScrollAdjustment + element.scrollLeft) *
(i.railXWidth - i.scrollbarXWidth)) /
(i.contentWidth - i.containerWidth)
);        
*/
    const railMeasure = Math.round(rail.getBoundingClientRect().width);

    const thumbMeasure = getThumbSize(
        i.minScrollbarLength,
        i.maxScrollbarLength,
        toInt((railMeasure * i.containerWidth) / i.contentWidth)
    );

    const thumbOffset = toInt(
        ((i.negativeScrollAdjustment + i.scrollLeft) *
            (railMeasure - thumbMeasure)) /
            (i.contentWidth - i.containerWidth)
    );

    return { railMeasure, thumbMeasure, thumbOffset };
}
